(function(){
  "use strict";
  var KEY = (document.body.getAttribute("data-guide") || "guide") + ":";
  function load(k){ try { return localStorage.getItem(KEY+k); } catch(e){ return null; } }
  function save(k,v){ try { v === null ? localStorage.removeItem(KEY+k) : localStorage.setItem(KEY+k,v); } catch(e){} }

  /* ---- 1–5 rating rows ---- */
  var rows = document.querySelectorAll(".rate .rrow[data-k]");
  Array.prototype.forEach.call(rows, function(row){
    var key = row.getAttribute("data-k");
    var scale = row.querySelector(".scale");
    if(!scale) return;
    scale.setAttribute("role","radiogroup");
    var label = row.querySelector(".rl b");
    if(label) scale.setAttribute("aria-label", label.textContent + " — rate 1 to 5");
    scale.innerHTML = "";
    for(var i=1;i<=5;i++){
      var b = document.createElement("button");
      b.type = "button"; b.className = "sbox";
      b.setAttribute("role","radio"); b.setAttribute("aria-checked","false");
      b.setAttribute("aria-label", String(i)); b.setAttribute("data-v", String(i));
      b.innerHTML = '<span class="num">'+i+'</span>';
      scale.appendChild(b);
    }
    var boxes = scale.querySelectorAll(".sbox");
    function paint(v){
      Array.prototype.forEach.call(boxes, function(b){
        b.setAttribute("aria-checked", b.getAttribute("data-v") === v ? "true" : "false");
      });
    }
    paint(load(key));
    scale.addEventListener("click", function(e){
      var b = e.target.closest(".sbox"); if(!b) return;
      var v = b.getAttribute("data-v");
      var next = (load(key) === v) ? null : v;   /* click again to clear */
      save(key, next); paint(next);
    });
    scale.addEventListener("keydown", function(e){
      if(e.key !== "Enter" && e.key !== " ") return;
      var b = e.target.closest(".sbox"); if(!b) return;
      e.preventDefault(); b.click();
    });
  });

  /* ---- week-by-week tracker ---- */
  var cells = document.querySelectorAll("td.cell[data-k]");
  Array.prototype.forEach.call(cells, function(td){
    var key = td.getAttribute("data-k");
    var sel = document.createElement("select");
    sel.className = "tsel";
    sel.setAttribute("aria-label", td.getAttribute("data-label") || key);
    sel.innerHTML = '<option value="">—</option><option>1</option><option>2</option>'
                  + '<option>3</option><option>4</option><option>5</option>';
    var v = load(key) || "";
    sel.value = v; sel.setAttribute("data-filled", v ? "1" : "0");
    sel.addEventListener("change", function(){
      save(key, sel.value || null);
      sel.setAttribute("data-filled", sel.value ? "1" : "0");
    });
    td.textContent = ""; td.appendChild(sel);
  });

  /* ---- clear buttons ---- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-clear]"), function(btn){
    btn.addEventListener("click", function(){
      var scope = btn.getAttribute("data-clear");
      Array.prototype.forEach.call(document.querySelectorAll('.rate .rrow[data-k], td.cell[data-k]'), function(el){
        if(scope !== "all" && el.getAttribute("data-k").indexOf(scope) !== 0) return;
        save(el.getAttribute("data-k"), null);
      });
      location.reload();
    });
  });
})();
